import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24e8107a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=24e8107a&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=24e8107a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e8107a",
  null
  
)

export default component.exports